import AuthShell from "../Components/auth/AuthShell";
import CustomerAuthForm from "../Components/auth/CustomerAuthForm";

export default function PasswordRescue() {
    return <AuthShell title="Recuperar acceso" description="Verificá tu email para cambiar tu contraseña o entrar directamente.">
        <CustomerAuthForm recovery />
    </AuthShell>;
}
